module.exports = __webpack_public_path__ + "static/media/headerBanner.cdc19f31.png";